import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    productId: String,
    productName: String
  }

  connect() {
    this.element.addEventListener('turbo:submit-end', this.handleSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-end', this.handleSubmitEnd)
  }

  handleSubmitEnd = (event) => {
    if (event.detail.success && typeof gtag === 'function') {
      gtag('event', 'add_to_cart', {
        item_id: this.productIdValue,
        item_name: this.productNameValue,
      })
    }
  }
}